import React from "react";
import { BaseQuestionType, getExerciseQuestionInfo } from "service/exercise";
import { errorMessage } from "service/service";
import TopicPreviewGroup from "../TopicPreviewGroup";
import useRequest from "../../../../../../../utils/useRequest";
import TopicPreviewItem from "../TopicPreviewItem";

interface OptionType {
    id: number; //选项id
    description: string; //选项描述
    isRight: BooleanValue; //是否正确0:不是 1:正确
}

export interface QuestionItem {
    queTypeId: BaseQuestionType; //大题的类型
    contentText: string; //原题目
    analysis?: string; //主观题答案
    score: string; //分数
    queTypeName: string; //题型名称
    optionModelList: OptionType[];
    questionModelList?: QuestionItem[];
}

interface TopicDetailProps {
    questionId: number;
    data: QuestionItem;
}

export default function TopicPreview({ questionId }: TopicDetailProps) {
    const [data, { loading, error }] = useRequest(() =>
        getExerciseQuestionInfo(questionId)
    );

    if (error) return <div>{errorMessage(error)}</div>;
    if (!data || loading) return <div>加载中....</div>;

    if (data.queTypeId > 5) return <TopicPreviewGroup data={data} />;
    return <TopicPreviewItem data={data} />;
}
